import * as React from 'react';
import { Icon } from '@amzn/awsui-components-react/polaris';
// TODO: According to https://polaris.corp.amazon.com/system/structures/help_panel/ the official
//  help panel widget is coming soon. We should switch to that when it arrives
const HelpPanel = ({ title, content, links }) => (
// TODO: This doesn't display correctly yet
React.createElement("div", { className: "awsui-util-help-panel" },
    React.createElement("div", { className: "awsui-util-help-panel-header" },
        React.createElement("h2", null, title)),
    content,
    links && (React.createElement("div", { className: "awsui-util-help-panel-footer" },
        React.createElement("h3", null,
            "Learn more ",
            React.createElement(Icon, { name: "external" })),
        React.createElement("ul", null, links.map((link) => (React.createElement("li", { key: link.url },
            React.createElement("a", { href: link.url }, link.label)))))))));
export default HelpPanel;
//# sourceMappingURL=HelpPanel.js.map